import { useQuery } from "@tanstack/react-query";
import { useAuth } from "auth";
import { useSelector } from "react-redux";
import issuer_services from "services/issuer_services";
import {
  networkTypeSelector,
  treasuryIdSelector,
} from "store/userSliceHelpers";

export function useMerchantsCount() {
  const { user } = useAuth();
  const treasuryId = useSelector(treasuryIdSelector);
  const networkType = useSelector(networkTypeSelector);
  return useQuery({
    // treasuryId is in the key because the queryFn reads it — the count is per-treasury.
    queryKey: ["merchantsCount", treasuryId],
    queryFn: () => issuer_services.getMerchantsCount(treasuryId!, networkType),
    enabled: !!user && !!treasuryId,
  });
}
